/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable react/forbid-elements */
/* eslint-disable @typescript-eslint/no-empty-function */

import { FC } from "react";
import { setCookie } from "../miscellaneous/cookieManagement";

export type Props = {
  readonly currencyIso?: string;
  readonly isOnClickDisabled?: boolean;
  readonly savePreferedCurrencyDetailsCallBack?: () => void;
};

export const BreadCrumbsCurrencyOption: FC<Props> = ({
  currencyIso,
  isOnClickDisabled,
  savePreferedCurrencyDetailsCallBack,
}) => {
  const selectCurrencyHandler = () => {
    if (currencyIso) {
      setCookie("MkHcCurrencyId", currencyIso);
      window.location.reload();
    }
  };

  return (
    <div className="mkhc-hover-link-container">
      <button
        className="mkhc-hover-link"
        onClick={isOnClickDisabled ? undefined : selectCurrencyHandler}
      >
        <span className="tw-font-medium tw-whitespace-nowrap">
          {currencyIso}
        </span>
      </button>
    </div>
  );
};
